"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showPrintHelp = exports.checkBrowser = exports.getScreenResolution = exports.proxyURL = exports.validateURL = void 0;
const toastr_1 = __importDefault(require("toastr"));
const Bowser = __importStar(require("bowser"));
const settings_1 = require("~/settings");
const locale_1 = require("~/services/locale");
/**
 * Valide une URL.
 *
 * @param {string} value:
 *             L'URL à tester / valider.
 *
 * @returns {boolean} True si l'URL est valide, False sinon.
 */
function validateURL(value) {
    const urlRegExp = /^https?:\/\/[a-z0-9-\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?$/i;
    return urlRegExp.test(value);
}
exports.validateURL = validateURL;
;
/**
 * Proxyfie une url.
 *
 * @param {string} url:
 * 				L'URL à proxyfier
 *
 * @returns {string} L'URL proxyfiée
 */
function proxyURL(url) {
    return [settings_1.settings.baseUrl, 'fr/', settings_1.settings.proxyUrl, encodeURIComponent(url)].join('');
}
exports.proxyURL = proxyURL;
;
let _screenResolution;
/**
 * Retourne larésolution de l'écran, en px / m
 */
function getScreenResolution() {
    // On cache
    if (_screenResolution == undefined) {
        const $meter = $('<div style="width: 10cm;"></div>');
        $('body').append($meter);
        _screenResolution = $meter.width() * 10; // px/m
        $meter.remove();
    }
    return _screenResolution;
}
exports.getScreenResolution = getScreenResolution;
;
/**
 * Vérifie la compatibilité avec le navigateur et préconise une version si besoin.
 */
function checkBrowser() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserName = browser.getBrowserName(true);
    console.log("Browser is", browserName);
    if (!['chrome', 'firefox'].includes(browserName)) {
        toastr_1.default.info((0, locale_1.t)('utils.checkBrowser'));
    }
}
exports.checkBrowser = checkBrowser;
;
function showPrintHelp() {
    toastr_1.default.info((0, locale_1.t)('utils.helpPrint'));
}
exports.showPrintHelp = showPrintHelp;
;
